import merge from 'lodash/merge'
import { omit } from 'lodash'
import { SET_EDIT_STAY_GUEST } from '../actions/setEditStayGuest'
import { REMOVE_EDIT_STAY_GUEST } from '../actions/removeEditStayGuest'

const initialState = {
}

export default function editStayGuestReducer(state = initialState, action) {
	switch(action.type) {

		case SET_EDIT_STAY_GUEST:
			// Select editStayGuest manually
			return merge({}, state, action.payload)

		case REMOVE_EDIT_STAY_GUEST:
			// Remove editStayGuest by roomGroup
			return omit(state, action.payload)

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/editStayGuestReducer.js